import PravoEuDetail from './PravoEuDetail';

export default PravoEuDetail;
